export const GET_SOLARGRAF_PROJECTS_REQUEST = 'GET_SOLARGRAF_PROJECTS_REQUEST';
export const GET_SOLARGRAF_PROJECTS_SUCCESS = 'GET_SOLARGRAF_PROJECTS_SUCCESS';
export const GET_SOLARGRAF_PROJECTS_FAILURE = 'GET_SOLARGRAF_PROJECTS_FAILURE';

export const GET_SOLARGRAF_PROJECT_DETAILS_REQUEST = 'GET_SOLARGRAF_PROJECT_DETAILS_REQUEST';
export const GET_SOLARGRAF_PROJECT_DETAILS_SUCCESS = 'GET_SOLARGRAF_PROJECT_DETAILS_SUCCESS';
export const GET_SOLARGRAF_PROJECT_DETAILS_FAILURE = 'GET_SOLARGRAF_PROJECT_DETAILS_FAILURE';

export const COLUMNS = [
  { id: 'icon', label: '', minWidth: 10 },
  { id: 'project_name', label: 'Project Name', minWidth: 120 },
  { id: 'address', label: 'Address', minWidth: 200 },
  { id: 'status', label: 'Status', minWidth: 120 },
  { id: 'last_modified', label: 'Last Modified', minWidth: 120 }
];
